import { Container } from "aurelia-dependency-injection";
import { TemplateManager } from "./../../../shared/helpers/template-manager";
import { DocumentEvents } from "./../../helpers/document-events";
import { IDocumentModel } from "./../../interfaces/document-model";
import { GenericTabModel } from "./../../models/tabs/generic-tab";
import { backboneViewProperties } from "./../../../decorators/backbone-properties";
import { AppEvents } from "./../../../app-events";
import { ContainerHelper } from "../../../shared/helpers/container-helper";

const template = require<string>("./case-overview.html");
const dom = {
    ALL_QUOTED_BUTTON: ".all-quoted-button",
    DISPLAY_POWER_PARA: ".display-power-para",
    PROCESSING_STATUS_CONTAINER : ".document-processing-status",

};

@backboneViewProperties({
    template
})
export class CaseOverviewTabView extends Marionette.ItemView<any> {
    public model: IDocumentModel;
    private appEvents: Backbone.Events;

    constructor(options?) {
        super(options);
        this.appEvents = ContainerHelper.Events;
    }

    public onShow() {
        this.setupDocumentProcessingStatusPopover();
        this.listenTo(this.model, DocumentEvents.AllQuotedParagraphsToggle, this.allQuotedParaToggle);
    }

    public allQuotedParaToggle(data) {
        this.$(dom.ALL_QUOTED_BUTTON).toggleClass("active", data.showing);
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click " + dom.ALL_QUOTED_BUTTON] = (e) => this.highlightAllClicked(e);
        events["click " + dom.DISPLAY_POWER_PARA] = (e) => this.displayPowerParaClicked(e);
        return events;
    }
    private highlightAllClicked(e: JQueryEventObject) {
        this.appEvents.trigger(AppEvents.AppInsightsDocumentHighlightQuotedClicked, {Button: "Clicked"});
        this.model.trigger(DocumentEvents.HighlightAllQuotedParagraphs);
    }
    private displayPowerParaClicked(e: JQueryEventObject) {
        const paraNum = $(e.currentTarget).attr("para-num");
        this.appEvents.trigger(AppEvents.AppInsightsDocumentPowerParaClicked, {ParaNum: paraNum});
        this.model.trigger(DocumentEvents.ShowPowerPara, paraNum);
    }
    private setupDocumentProcessingStatusPopover() {
        const $objProcessing = this.$(dom.PROCESSING_STATUS_CONTAINER);
        let hdr = "Processing status: ";

        if (this.model.get("FailedProcessing")) {
            hdr += "Failed";
            $objProcessing.removeClass("processing-completed").addClass("processing-failed");
        } else {
            hdr += "Completed";
            $objProcessing.removeClass("processing-failed").addClass("processing-completed");
        }

        const html = (this.model.get("LastBatchId") === "00000000-0000-0000-0000-000000000000") ?
                    "Batch information not available" :
                    "See the latest <a class='processing-link' href='processing/batch/" + this.model.get("LastBatchId") + "/" + this.model.get("EntityId") + "'>process log</a>";

        $objProcessing.attr("data-content", html);
        $objProcessing.attr("title", hdr);

        $objProcessing.popover({
            placement: "right",
            html: true,
            trigger: "manual",
            container: "body"
        })
        .hover((e) => { this.$(dom.PROCESSING_STATUS_CONTAINER).attr("title", hdr); })
        .click((e) => {
            this.$(dom.PROCESSING_STATUS_CONTAINER).popover("show");
            return false;
        });

    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/tabs/case-overview.ts